import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import moment from 'moment';
import {
  AddIconButton,
  DeleteIconButton,
  RemoveIconButton,
} from '../../../../components/common/button/CustomIconButton';
import { Grid } from '@mui/material';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
interface IProps {
  item: any;
  isView: any;
  handleDelete: any;
  index: number;
  setPartIdx: React.Dispatch<React.SetStateAction<number>>;
  setIsOpenPopup: React.Dispatch<React.SetStateAction<boolean>>;
  defects: any;
}

const TBodyRow = ({
  item,
  index,
  isView,
  handleDelete,
  setPartIdx,
  setIsOpenPopup,
  defects,
}: IProps) => {
  const [rowRender, setRowRender] = useState(false);

  const handleChange = (e: any) => {
    item[e.target.name] = e.target.value;
    setRowRender((prev: any) => !prev);
  };

  return (
    <>
      <tr>
        <td style={{ textAlign: 'center', minWidth: '160px' }}>
          <DatePickerMui
            label=""
            onChange={(date) => {
              item.date = moment(date || null);
              setRowRender((prev: any) => !prev);
            }}
            value={(item?.date && moment(item?.date)) || null}
          />
        </td>
        <td>{index + 1}</td>
        <td style={{ minWidth: '250px' }}>
          {isView ? (
            item?.part_id && item.part_id?.part_name
          ) : (
            <Grid container xs={12} direction="row" alignItems={'center'}>
              <Grid item xs={10}>
                <p
                  style={{
                    fontSize: '1.2rem',
                  }}
                >
                  {typeof item?.part_id === 'object' && item?.part_id !== null
                    ? item.part_id?.part_name
                    : item?.partName}
                  {!item?.part_id && 'Pick Part Name'}
                </p>
              </Grid>

              {item.part_id ? (
                <Grid item xs={2}>
                  <RemoveIconButton
                    tooltipTitle="remove part"
                    onClick={() => {
                      item.part_id = null;
                      item.partNumber = null;
                      item.partName = null;
                      item.customerName = null;
                      setRowRender((prev: any) => !prev);
                    }}
                  />
                </Grid>
              ) : (
                <Grid item xs={2}>
                  <AddIconButton
                    tooltipTitle="add part"
                    onClick={() => {
                      setIsOpenPopup(true);
                      setPartIdx(index);
                    }}
                  />
                </Grid>
              )}
            </Grid>
          )}
        </td>
        <td style={{ width: '200px', minWidth: '200px' }}>
          {item?.part_id?.part_number || item?.partNumber}
        </td>
        <td style={{ width: '200px', minWidth: '200px' }}>
          {item?.part_id?.customer_id?.customer_name || item?.customerName}
        </td>
        <td style={{ textAlign: 'center', minWidth: '120px', width: '120px' }}>
          <TableInput
            isView={isView}
            type="number"
            name="qty"
            value={item?.qty ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        <td style={{ textAlign: 'center', width: '200px', minWidth: '200px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="desc_non_confirmity"
            value={item?.desc_non_confirmity ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        <td>
          <AutocompleteMuiCustom
            id="Defect"
            label=""
            option_name="defect_name"
            arrayofObj={defects}
            value={item.defect_id || ''}
            onChange={(e, value) => {
              item.defect_id = value;
              setRowRender((prev: any) => !prev);
            }}
            sx={{ width: 200, margin: 2 }}
          />
        </td>
        <td style={{ textAlign: 'center', width: '200px', minWidth: '200px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="desposition_req"
            value={item?.desposition_req ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        <td style={{ textAlign: 'center', width: '150px', minWidth: '150px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="sign_prod"
            value={item?.sign_prod ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        <td style={{ textAlign: 'center', width: '150px', minWidth: '150px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="sign_qa"
            value={item?.sign_qa ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        <td style={{ textAlign: 'center', width: '150px', minWidth: '150px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="sign_store"
            value={item?.sign_store ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        <td style={{ textAlign: 'center', width: '150px', minWidth: '150px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="sign_plan_head"
            value={item?.sign_plan_head ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        <td style={{ textAlign: 'center' }}>
          <TableInput
            isView={isView}
            type="text"
            name="remarks"
            value={item?.remarks ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        {!isView && (
          <td style={{ textAlign: 'center' }}>
            <DeleteIconButton
              tooltipTitle="DELETE"
              onClick={() => {
                handleDelete(item?._id, index);
              }}
            />
          </td>
        )}
      </tr>
    </>
  );
};

export default TBodyRow;
